import { JobFunction } from '../../../../../../graphql';

export const UNDERWRITER_EMPLOYEE_JOB_FUNCTIONS = {
  [JobFunction.Sales]: 'Sales',
  [JobFunction.Trading]: 'Trading',
  [JobFunction.Syndicate]: 'Syndicate',
};

export const UNDERWRITER_EMPLOYEE_JOB_FUNCTION_OPTIONS = (
  Object.keys(
    UNDERWRITER_EMPLOYEE_JOB_FUNCTIONS
  ) as (keyof typeof UNDERWRITER_EMPLOYEE_JOB_FUNCTIONS)[]
).map(jobFunction => ({
  label: UNDERWRITER_EMPLOYEE_JOB_FUNCTIONS[jobFunction],
  value: jobFunction,
}));
